import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-pointe-settings',
  templateUrl: './job-pointe-settings.component.html',
  styleUrls: ['./job-pointe-settings.component.scss'],
})
export class JobPointeSettingsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
